export const PUSHNOTIFICATION_START = 'PUSHNOTIFICATION_START';
export const PUSHNOTIFICATION_LISTEN_START = 'PUSHNOTIFICATION_LISTEN_START';
export const UPDATE_FCM_TOKEN = 'UPDATE_FCM_TOKEN';
export const FETCH_NOTIFICATION_DETAIL_START =
  'FETCH_NOTIFICATION_DETAIL_START';
export const FETCH_NOTIFICATION_DETAIL_SUCCESS =
  'FETCH_NOTIFICATION_DETAIL_SUCCESS';
export const FETCH_NOTIFICATION_DETAIL_FAILED =
  'FETCH_NOTIFICATION_DETAIL_FAILED';
